  <mat-toolbar color="primary">
    <img
      [src]="logo"
      alt="logo"
    >
    <div class="title">
      <span>Insider Trading Alerts</span>
      <!-- <p class='sub-title'>Chrome extension</p> -->
    </div>
    <ul>
      <!-- <li><span
          class="menu-item"
          (click)="openDialog('signup')"
          routerLinkActive="active-link"
        >Sign Up</span></li>
      <li><span
          class="menu-item"
          (click)="openDialog('login')"
          routerLinkActive="active-link"
        >Log in</span></li> -->
      <li><span
          class="menu-item"
          routerLink="/privacy"
          routerLinkActive="active-link"
        >Privacy</span></li>
      <li><span
          class="menu-item"
          routerLink="/disclaimer"
          routerLinkActive="active-link"
        >Disclaimer</span></li>
      <li><span
          class="menu-item"
          routerLink="/upgrade"
          routerLinkActive="active-link"
        >Upgrade</span></li>
      <!-- <li><span
          class="menu-item"
          routerLink="/filings"
          routerLinkActive="active-link"
        >Latest Filings</span></li> -->
    </ul>
  </mat-toolbar>
